import Swal from "sweetalert2";

export const handleCreateTour = ({
  MySwal,
  formRef,
  tours,
  fetchData,
  CreateTourForm,
  cars,
  rentals,
  coupons,
  contact,
  drivers,
  tourBookings,
  employeeService,
  setCarsData,
  setRentalsData,
  setCouponsData,
  setTransfersData,
  setDriversData,
  setToursData,
  setTourBookingsData,
  setEmployeesData,
  setSeasonalPricing,
  setIsLoading,
  setError,
}) => {
  MySwal.fire({
    title: "Create New Tour",
    html: <CreateTourForm ref={formRef} />,
    showCancelButton: true,
    confirmButtonText: "Create Tour",
    confirmButtonColor: "#1e3a8a",
    cancelButtonColor: "#d33",
    width: "800px",
    preConfirm: () => {
      const tourData = formRef.current?.getFormData();

      if (!tourData) {
        Swal.showValidationMessage(
          `Please fill all required fields correctly.`
        );
        return false;
      }
      return tourData;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const tourData = result.value;

      // Create FormData object
      const formData = new FormData();

      // Append all tour data
      formData.append("name", tourData.name);
      formData.append("description", tourData.description);
      formData.append("duration", tourData.duration);
      formData.append("maxPersons", tourData.maxPersons);
      formData.append("vehicleType", tourData.vehicleType);
      formData.append("isActive", tourData.isActive);

      // Add the image file if it exists
      if (tourData.tourImage) {
        formData.append("tourImage", tourData.tourImage);
      }

      for (const vehicle in tourData.pricing) {
        for (const season in tourData.pricing[vehicle]) {
          formData.append(
            `pricing[${vehicle}][${season}]`,
            tourData.pricing[vehicle][season]
          );
        }
      }

      // Append locations and highlights arrays
      tourData.locations.forEach((loc) => formData.append("locations[]", loc));
      tourData.highlights.forEach((h) => formData.append("highlights[]", h));

      tours
        .create(formData)
        .then(() => {
          MySwal.fire({
            icon: "success",
            title: "Tour Created!",
            text: "The tour has been created successfully.",
            confirmButtonColor: "#1e3a8a",
            iconColor: "#10B981", // Use MySwal's iconColor prop
          });
          fetchData();
        })
        .catch((error) => {
          console.error("Error creating tour:", error);
          // Attempt to get specific error message from backend response if available
          const errorMsg =
            error.response?.data?.message ||
            error.message ||
            "An unknown error occurred.";
          MySwal.fire({
            // Use MySwal
            icon: "error",
            title: "Creation Failed",
            text: `Failed to create tour: ${errorMsg}`,
            confirmButtonColor: "#1e3a8a",
          });
        });
    }
  });
};
